module.exports = __webpack_public_path__ + "img/2_105.2f955ef4.png";